import axios from "./HttpClient";

const identityURL = IdentityServerUrl;

export function GetOrganization(id) {
    return axios.get(`${identityURL}api/organizations/${id}`);
}

export function PostOrganization(data) {
    return axios.post(`${identityURL}api/organizations/`, data);
}

export function PutOrganization(id, data) {
    return axios.put(`${identityURL}api/organizations/${id}`, data);
}

export function GetUserInfo() {
    return axios.get(`${identityURL}connect/userinfo`);
}

export function GetUser() {
    return axios.get(`${identityURL}account/CurrentLoggedInUser`);
}

export function UpdateUser(user) {
    return axios.post(`${identityURL}api/AccountActions/UpdateUser`, user);
}

export function UpdateUserData(userID, organizationID, data) {
    return axios.post(`${identityURL}api/UserData/${userID}`, { userID, organizationID, data });
}

export function ResolveUsers(users) {
    return axios.post(`${identityURL}api/Users/$resolve`, { users }).then((response) => {
        return response.data;
    });
}

export async function SearchUsers(user, query) {
    let headers = { "x-sca-ide-org-context": user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    let users = [];

    let resUsers = [];
    let i = 0;
    do {
        resUsers = await axios.get(`${identityURL}api/Users/searchUsers`, { params: { query, limit: 50, skip: i * 50 }, headers }).then((response) => {
            return response.data;
        });

        i++;

        users.push(...resUsers);
    } while (resUsers.length == 50);

    return users;
}

export function GetIdentityGroups(organizationId) {
    return axios.get(`${identityURL}api/Groups/${organizationId}`).then((response) => {
        return response.data;
    });
}

export function GetIdentityGroupMembers(groupId) {
    return axios.get(`${identityURL}api/Groups/${groupId}/members`).then((response) => {
        return response.data;
    });
}

export function ListStorage(db, cnt) {
    return axios.get(`${identityURL}api/SSAStorage/List`, { params: { db, cnt } }).then((response) => {
        return response.data;
    });
}

export function GetGuides(key) {
    return axios.get(`${identityURL}api/Guides/GetGuides`, { params: { key } }).then((response) => {
        return response.data;
    });
}

export function CreateUser(user) {
    return axios.post(`${identityURL}api/Users/createUser`, user).then((response) => {
        return response.data;
    });
}

export function SendUserLoginLink(user, organization) {
    return axios.post(`${identityURL}Account/SendUserLoginLink`, { userID: user.id, organizationID: organization.id, link: identityURL + "#redirect=" + window.location.origin, minutes: 43200 }).then((response) => {
        return response;
    });
}

export function SendBulkUserLoginLink(users, organization) {
    return axios.post(`${identityURL}Account/SendBulkUserLoginLink`, { userIDs: users.map((u) => u.id), organizationID: organization.id, link: identityURL + "#redirect=" + window.location.origin, minutes: 43200 }).then((response) => {
        return response;
    });
}

export interface Organization {
    id: string;
    name: string;
}
